import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

const categoryImages = {
  Rings: [
    'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&h=400&fit=crop',
    'https://i5.walmartimages.com/seo/14KT-Yellow-Gold-Round-Diamond-Halo-Matching-Wedding-Ring-Set-1-0-625-CTTW-Size-7_e591f1fc-53c0-4915-a2d5-66d7fac10414.b84e81c03e346d18a837b17af520392a.jpeg',
    'https://i.etsystatic.com/10797896/r/il/fbe3fc/1682987455/il_794xN.1682987455_t0i1.jpg',
    'https://www.candere.com/media/jewellery/images/LCR0567_1.jpg',
    'https://www.beejewel.com.au/jpegs_400a/18Y24513_GIA971.jpg',
    'https://tse4.mm.bing.net/th/id/OIP.TZukttnxlJZ3ejSOxXazAQHaHa?w=504&h=504&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://i.pinimg.com/200x150/4b/92/d0/4b92d09317216640a660ea99f98a8a6f.jpg',
    'https://tse1.mm.bing.net/th/id/OIP.E-0P785flcjX22fBCEenEQHaHa?pid=ImgDet&w=474&h=474&rs=1&o=7&rm=3',
    'https://th.bing.com/th/id/OIP.lD5Csc6Tw8FlkptxKXdUyAHaHa?w=191&h=191&c=7&r=0&o=7&pid=1.7&rm=3',
    'https://img0.etsystatic.com/122/0/11488058/il_fullxfull.937231242_tin5.jpg',
  ],
  Necklaces: [
    'https://i.etsystatic.com/10294082/r/il/a7caa2/2142299069/il_1080xN.2142299069_i39e.jpg',
    'https://i.etsystatic.com/11238098/r/il/2fa299/2873257928/il_fullxfull.2873257928_j5ks.jpg',
    'https://i.etsystatic.com/6382786/r/il/9f81dc/2250367788/il_fullxfull.2250367788_2b0u.jpg',
    'https://i.etsystatic.com/25998097/r/il/2f50e1/4346758699/il_1140xN.4346758699_sq98.jpg',
    'https://cdn.shopify.com/s/files/1/0602/1267/4755/files/NECKLACE-MM_1500x.jpg?v=1643706605',
    'https://i.etsystatic.com/11466881/r/il/31d3e7/1703817167/il_794xN.1703817167_6s5a.jpg',
    'https://i.etsystatic.com/11298852/r/il/e81994/2711643399/il_fullxfull.2711643399_tl8s.jpg',
    'https://tse1.explicit.bing.net/th/id/OIP.XqcN_-i-AWlJlDwN2R9O7AHaF-?rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://tse1.explicit.bing.net/th/id/OIP.3BboqV1VyNuNTHobuTE51wHaJQ?w=843&h=1054&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://i.pinimg.com/originals/3b/08/2c/3b082cbcc023ac7ae377ee110b26fd32.jpg',
  ],
  Bangles: [
    'https://i.etsystatic.com/13151875/r/il/9c83fd/3933406756/il_1080xN.3933406756_nw3f.jpg',
    'https://southindiajewels.com/wp/wp-content/uploads/2023/01/Bangle-7.jpg',
    'https://images-static.nykaa.com/media/catalog/product/tr:h-800,w-800,cm-pad_resize/e/7/e76cc05ba-pr-40068-2-8.c.jpg',
    'https://3.imimg.com/data3/XH/GR/MY-15406381/gold-bangles-1000x1000.png',
    'https://i.etsystatic.com/43679932/r/il/5c0597/5870488421/il_300x300.5870488421_ce0c.jpg',
    'https://simplecraftidea.com/wp-content/uploads/2020/04/Gold-bangle-3.jpg',
    'https://5.imimg.com/data5/ZT/RU/QI/SELLER-15021660/designer-gold-bangle-1000x1000.jpg',
    'https://supergoldjeweller.ca/wp-content/uploads/2023/02/DSC1832.jpg',
    'https://tse2.mm.bing.net/th/id/OIP.DOIjsVngOAUhOZmODKKZoAHaEi?w=1024&h=628&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://shop.southindiajewels.com/wp-content/uploads/2023/09/Stunning-Pearl-Studded-Gold-Plated-Bangle-Set-Set-of-4-01-570x570.jpg',
  ],
  Earrings: [
    'https://tse2.mm.bing.net/th/id/OIP.afZXVqM2i6Cetqqy85RQfQHaLz?w=740&h=1180&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://www.jiomart.com/images/product/500x630/rv6aggreve/bodha-by-shivansh-24k-chandelier-chandbali-gold-earrings-for-women-product-images-rv6aggreve-0-202211300835.jpg',
    'https://i.etsystatic.com/37070808/r/il/deb5bc/6278338395/il_1080xN.6278338395_b01y.jpg',
    'https://tse2.mm.bing.net/th/id/OIP.76eD3p50JReMQAeBjJgX6QHaHa?rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://www.dhanalakshmijewellers.com/wp-content/uploads/2021/02/image-10-1024x576.png',
    'https://tribe.blob.core.windows.net/tribe2018/catalog/00/22/22526_1_eb3a22a20e8c4ccfb1b2751d59cf2c1b.jpg',
    'https://www.tanishq.com/on/demandware.static/-/Sites-Tanishq-site-catalog/default/dwf640b434/images/hi-res/514005HULAAA00_1.jpg',
    'https://tse2.mm.bing.net/th/id/OIP.qzSfnauHM4eiOhme9jgKfAHaJ4?w=794&h=1059&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://tse3.mm.bing.net/th/id/OIP.OeAEVpmW-YPCxt1zhft47QHaHa?w=800&h=800&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://tse3.mm.bing.net/th/id/OIP.gmDySXrLcOig46WbRbwcPQHaHa?w=1080&h=1080&rs=1&pid=ImgDetMain&o=7&rm=3',
  ],
};

const categories = [
  { name: 'Rings', path: '/rings', image: categoryImages.Rings[0] },
  { name: 'Necklaces', path: '/necklaces', image: categoryImages.Necklaces[0] },
  { name: 'Bangles', path: '/bangles', image: categoryImages.Bangles[0] },
  { name: 'Earrings', path: '/earrings', image: categoryImages.Earrings[0] },
];

const generateProductDetails = (category, index) => {
  const names = {
    Rings: ['Diamond Solitaire', 'Gold Halo Ring', 'Emerald Ring', 'Sapphire Ring', 'Ruby Ring', 'Platinum Band', 'Vintage Ring', 'Eternity Band', 'Pearl Ring', 'Opal Ring'],
    Necklaces: ['Gold Chain', 'Diamond Pendant', 'Pearl Necklace', 'Emerald Necklace', 'Ruby Choker', 'Sapphire Necklace', 'Layered Necklace', 'Temple Necklace', 'Antique Necklace', 'Bridal Necklace'],
    Bangles: ['Gold Bangle Set', 'Diamond Bangles', 'Pearl Bangles', 'Designer Bangles', 'Antique Bangles', 'Ruby Bangles', 'Emerald Bangles', 'Traditional Bangles', 'Modern Bangles', 'Stackable Bangles'],
    Earrings: ['Jhumka Earrings', 'Chandbali Earrings', 'Stud Earrings', 'Hoop Earrings', 'Drop Earrings', 'Chandelier Earrings', 'Pearl Earrings', 'Diamond Earrings', 'Gold Earrings', 'Antique Earrings'],
  };
  const categoryNames = names[category] || Array(10).fill(`${category} Item`);
  const name = categoryNames[index % categoryNames.length] + ` ${index + 1}`;
  const description = `This exquisite ${category.toLowerCase()} is handcrafted by our master artisans using traditional techniques. The intricate design reflects timeless elegance and makes it perfect for special occasions.`;
  return { name, description };
};

const CategorySection = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [failedImages, setFailedImages] = useState({});
  const galleryRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (galleryRef.current && !galleryRef.current.contains(event.target)) {
        setSelectedCategory(null);
      }
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setSelectedProduct(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory((prev) => (prev === categoryName ? null : categoryName));
  };

  const openCategory = (categoryName) => {
    setSelectedCategory(categoryName);
  };

  const handleImageError = (id) => {
    setFailedImages((prev) => ({ ...prev, [id]: true }));
  };

  const getFallbackColor = (category, index) => {
    const colors = ['amber-200', 'amber-300', 'amber-400', 'amber-500', 'amber-600'];
    const hash = (category.length + index) % colors.length;
    return colors[hash];
  };

  const handleViewProduct = (img, category, idx) => {
    const details = generateProductDetails(category, idx);
    setSelectedProduct({ image: img, ...details, category, idx });
  };

  return (
    <section className="bg-orange-100 py-12 md:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-stone-800 mb-10">
          Shop By <span className="text-amber-600">Category</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8 justify-items-center">
          {categories.map((cat) => {
            const imageFailed = failedImages[cat.name];
            return (
              <div
                key={cat.name}
                onClick={() => handleCategoryClick(cat.name)}
                className="group relative flex flex-col overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-amber-300 w-full max-w-[280px] aspect-square box-border"
              >
                <div className="w-full h-full">
                  {!imageFailed ? (
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      onError={() => handleImageError(cat.name)}
                    />
                  ) : (
                    <div className={`w-full h-full bg-${getFallbackColor(cat.name, 0)} flex items-center justify-center`}>
                      <span className="text-stone-800 font-semibold text-xl">{cat.name}</span>
                    </div>
                  )}
                </div>

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex flex-col justify-end p-4">
                  <h3 className="text-white text-xl font-semibold mb-2">{cat.name}</h3>
                </div>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 pointer-events-none" />
              </div>
            );
          })}
        </div>
        {selectedCategory && (
          <div
            ref={galleryRef}
            className="mt-12 p-4 md:p-6 bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl border border-amber-200 animate-fade-in"
          >
            <h3 className="text-xl md:text-2xl font-bold text-stone-800 mb-6 text-center">
              <span className="text-amber-600">{selectedCategory}</span> Collection
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
              {categoryImages[selectedCategory].map((img, idx) => {
                const imageId = `${selectedCategory}-${idx}`;
                const imageFailed = failedImages[imageId];
                return (
                  <div
                    key={idx}
                    className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-2 border-amber-100 hover:border-amber-300"
                  >
                    <div className="aspect-square">
                      {!imageFailed ? (
                        <img
                          src={img}
                          alt={`${selectedCategory} ${idx + 1}`}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          onError={() => handleImageError(imageId)}
                          loading="lazy"
                        />
                      ) : (
                        <div className={`w-full h-full bg-${getFallbackColor(selectedCategory, idx)} flex items-center justify-center`}>
                          <span className="text-stone-800 text-xs text-center px-1">
                            {selectedCategory} {idx + 1}
                          </span>
                        </div>
                      )}
                    </div>
                    <button
                      onClick={() => handleViewProduct(img, selectedCategory, idx)}
                      className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center"
                    >
                      <span className="text-white text-xs md:text-sm font-medium bg-amber-600 px-2 py-1 md:px-3 md:py-1.5 rounded-full">
                        View Details
                      </span>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {selectedProduct && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
            <div
              ref={modalRef}
              className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            >
              <div className="relative">
                <button
                  onClick={() => setSelectedProduct(null)}
                  className="absolute top-4 right-4 text-stone-500 hover:text-stone-800 transition-colors z-10"
                >
                  <FaTimes size={24} />
                </button>
                <div className="p-6">
                  <div className="flex flex-col md:flex-row gap-6">
                    <div className="md:w-1/2">
                      <img
                        src={selectedProduct.image}
                        alt={selectedProduct.name}
                        className="w-full h-auto object-cover rounded-xl shadow-md"
                      />
                    </div>
                    <div className="md:w-1/2">
                      <h2 className="text-2xl font-bold text-stone-800 mb-2">{selectedProduct.name}</h2>
                      <p className="text-stone-600 mb-4">{selectedProduct.description}</p>
                      <div className="space-y-2">
                        <p className="text-sm text-stone-500">Category: {selectedProduct.category}</p>
                        <p className="text-sm text-stone-500">Item #: {selectedProduct.idx + 1}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeIn 0.5s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default CategorySection;